var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TranslationService } from "@imaginelearning/mps-api-service";
import { classMap, UxAvatar, UxAvatarPriorityEnum, UxNavbar, UxOrientationEnum, UxPriorityEnum, UxShadesEnum, UxSizeExtendedEnum, UxThemesEnum } from "@imaginelearning/mps-ux-component-library";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Actions from "./actions/actions";
import Footer from "./footer/footer";
import "./student-content-reader.scss";
import ContentReader from "../../ctk-reader-wrapper";
function StudentContentReader(_a) {
    var _this = this;
    var token = _a.token, lessonTitle = _a.lessonTitle, activityType = _a.activityType, doolittleBaseMediaUrl = _a.doolittleBaseMediaUrl, doolittleBaseApiUrl = _a.doolittleBaseApiUrl, _b = _a.doolittleVersion, doolittleVersion = _b === void 0 ? "1.3.770" : _b, debug = _a.debug, disableFastForward = _a.disableFastForward, isMasteryCheck = _a.isMasteryCheck, theme = _a.theme, showTextToSpeech = _a.showTextToSpeech, previewMode = _a.previewMode, selectedLanguage = _a.selectedLanguage, showLanguageTranslation = _a.showLanguageTranslation, closeCallback = _a.closeCallback, segmentStateChangeCallback = _a.segmentStateChangeCallback, takeSubmitCompleteCallback = _a.takeSubmitCompleteCallback, segmentReadyCallback = _a.segmentReadyCallback, languageChangeCallback = _a.languageChangeCallback, panelChangeCallback = _a.panelChangeCallback, avatar = _a.avatar, isSpanishContent = _a.isSpanishContent, disableAnnotations = _a.disableAnnotations, calculatorType = _a.calculatorType, shouldAutoPlay = _a.shouldAutoPlay, _c = _a.isAudioCompletionRequired, isAudioCompletionRequired = _c === void 0 ? false : _c, appEnv = _a.appEnv, itemEngineAuthorUri = _a.itemEngineAuthorUri, itemEngineItemsUri = _a.itemEngineItemsUri, footerAdditionalActions = _a.footerAdditionalActions;
    var initialSideKickMessageState = {
        show: false,
        msg: "",
        userDismissed: false,
        questionId: ""
    };
    var t = useTranslation().t;
    var _d = useState(initialSideKickMessageState), sideKickMessage = _d[0], setSideKickMessage = _d[1];
    var defaultSidekickMessage = "Try Again";
    var _e = useState(defaultSidekickMessage), retryMessage = _e[0], setRetryMessage = _e[1];
    var _f = useState(false), retryButton = _f[0], setRetryButton = _f[1];
    var actTypeValidation = activityType !== "" ? activityType : "Activity";
    var activityTypeString = isMasteryCheck ? "Mastery Check" : actTypeValidation;
    var headerChild = [
        {
            item: (React.createElement(Actions, { show: { Language: showLanguageTranslation }, languageChangeCallback: languageChangeCallback, selectedLanguage: selectedLanguage }))
        },
        {
            item: React.createElement(Actions, { ariaLabel: "Close", show: { Close: true }, closeCallback: closeCallback })
        }
    ];
    var displayTheme;
    switch (theme === null || theme === void 0 ? void 0 : theme.toLowerCase()) {
        case "k-2":
            displayTheme = UxThemesEnum.STUDENT_K_2;
            break;
        case "3-5":
            displayTheme = UxThemesEnum.STUDENT_3_5;
            break;
        case "6-8":
            displayTheme = UxThemesEnum.STUDENT_6_8;
            break;
        case "9-12":
            displayTheme = UxThemesEnum.STUDENT_9_12;
            break;
        default:
            displayTheme = UxThemesEnum.STUDENT_3_5;
            break;
    }
    var is6to12 = displayTheme === UxThemesEnum.STUDENT_6_8 || displayTheme === UxThemesEnum.STUDENT_9_12;
    var is912 = displayTheme === UxThemesEnum.STUDENT_9_12;
    var themeStr = String(displayTheme);
    require("../../themes/".concat(themeStr, ".scss"));
    var handleTryagainClick = function () {
        setRetryButton(false);
        setSideKickMessage(__assign(__assign({}, sideKickMessage), { show: false, userDismissed: true }));
    };
    var handleSideKickMessageUpdate = function (segment, closeOverrride) {
        setRetryButton(false);
        if (closeOverrride && sideKickMessage.show && !sideKickMessage.userDismissed) {
            setSideKickMessage({
                show: false,
                msg: retryMessage,
                userDismissed: true,
                questionId: ""
            });
            return;
        }
        var question = segment.components.find(function (item) { return item.type === "Question" || item.type === "QuestionItem"; });
        if (question) {
            var maxAttempts = question.maxAttempts, questionState = question.state;
            if (questionState.attempts === maxAttempts) {
                setRetryButton(false);
                setSideKickMessage({
                    show: false,
                    msg: retryMessage,
                    userDismissed: true,
                    questionId: ""
                });
            }
            if (questionState.attempts !== 0 &&
                questionState.correct !== null &&
                questionState.correct === false &&
                !sideKickMessage.userDismissed) {
                if (questionState.attempts && maxAttempts && questionState.attempts < maxAttempts) {
                    //  feedbackCompleted refers to the current attemptCount, so when attemptCount is 1 and feedbackCompleted is true that means feedback has been watched for attempt 1.
                    if (questionState.attempts === 1 && !questionState.feedbackCompleted) {
                        // question attempted once, feedback not watched
                        setRetryButton(true);
                    }
                    setSideKickMessage({
                        show: !!questionState.feedbackCompleted,
                        msg: retryMessage,
                        userDismissed: false,
                        questionId: question.id
                    });
                    if (questionState.feedbackCompleted) {
                        setTimeout(function () {
                            setSideKickMessage(__assign(__assign({}, sideKickMessage), { show: false, userDismissed: true }));
                        }, 6000);
                    }
                }
            }
            else {
                setRetryButton(false);
                setSideKickMessage({
                    show: false,
                    msg: retryMessage,
                    userDismissed: false,
                    questionId: question.id
                });
            }
        }
    };
    useEffect(function () {
        setSideKickMessage(__assign(__assign({}, sideKickMessage), { msg: retryMessage }));
    }, [retryMessage]);
    useEffect(function () {
        var translate = function (text) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(selectedLanguage && selectedLanguage !== "en")) return [3 /*break*/, 2];
                        return [4 /*yield*/, TranslationService.translateString(selectedLanguage, "en", text).then(function (x) { return setRetryMessage(x); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        setRetryMessage(text);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (sideKickMessage.show) {
            translate(defaultSidekickMessage);
        }
    }, [selectedLanguage, sideKickMessage.show]);
    return (React.createElement("div", { id: "student-content-reader", className: "student-content-reader h-100 ".concat(themeStr.replace(/_/g, "-")) },
        React.createElement(UxNavbar, { color: !is6to12 ? UxPriorityEnum.INFO : UxShadesEnum.DARK, sloganClassName: classMap("text-white fw-normal activity-type"), orientation: UxOrientationEnum.HORIZONTAL, items: headerChild, brand: {
                title: lessonTitle,
                type: "custom",
                logoClassName: "h4 text-white fw-normal"
            }, slogan: t("".concat(activityTypeString)), className: "px-4 ".concat(is6to12 ? "student-6-12-header" : "") }),
        React.createElement(ContentReader, { token: token, doolittleBaseMediaUrl: doolittleBaseMediaUrl, doolittleBaseApiUrl: doolittleBaseApiUrl, doolittleVersion: doolittleVersion, debug: !!debug, disableFastForward: !!disableFastForward, theme: theme, isSpanishContent: isSpanishContent, disableAnnotations: disableAnnotations, displayCorrectAnswer: !isMasteryCheck, shouldAutoPlay: shouldAutoPlay, isAudioCompletionRequired: isAudioCompletionRequired, appEnv: appEnv, scrollButtonText: t("Scroll"), itemEngineAuthorUri: itemEngineAuthorUri, itemEngineItemsUri: itemEngineItemsUri }),
        sideKickMessage.show && !sideKickMessage.userDismissed && (React.createElement("div", { className: "sidekick-message", onClick: handleTryagainClick, role: "button", "aria-live": "assertive", tabIndex: 0, onKeyDown: function () { return handleTryagainClick(); } },
            React.createElement("span", { className: "sidekick-label" }, "".concat(sideKickMessage.msg)),
            !is912 && (React.createElement(UxAvatar, { avatar: avatar, avatarType: UxAvatarPriorityEnum.DEFAULT, size: UxSizeExtendedEnum.X3, theme: displayTheme })))),
        React.createElement(Footer, { isMasteryCheck: !!isMasteryCheck, isSpanishContent: isSpanishContent, isRetryVisible: !!retryButton, showTextToSpeech: showTextToSpeech || false, theme: displayTheme, previewMode: previewMode || false, takeSubmitCompleteCallback: takeSubmitCompleteCallback, segmentStateChangeCallback: segmentStateChangeCallback, segmentReadyCallback: segmentReadyCallback, showLanguageTranslation: showLanguageTranslation, panelChangeCallback: panelChangeCallback, sideKickMessageCallback: handleSideKickMessageUpdate, calculatorType: calculatorType, additionalActions: footerAdditionalActions })));
}
export default StudentContentReader;
